import {useEffect, useState} from "react";
import {PencilSquareIcon} from "@heroicons/react/24/outline";
import Popup from "../../../../general/Popup.tsx";
import {GLASelector, type GlAccount} from "../../../GLASelector/index.ts";

interface BookToAccountModalProps {
    open: boolean;
    selectedCount: number;
    accounts: GlAccount[];
    currentAccountCode: string;
    onClose: () => void;
    onConfirm: (target: GlAccount) => void;
}

export function BookToAccountModal({
    open,
    selectedCount,
    accounts,
    currentAccountCode,
    onClose,
    onConfirm,
}: BookToAccountModalProps) {
    const [target, setTarget] = useState<GlAccount | null>(null);

    useEffect(() => {
        if (!open) return;
        setTarget(accounts.find((account) => account.id === currentAccountCode) ?? null);
    }, [open, accounts, currentAccountCode]);

    const targetIsCurrentAccount = target?.id === currentAccountCode;

    function handleConfirm() {
        if (!target || targetIsCurrentAccount) return;
        onConfirm(target);
        setTarget(null);
    }

    function handleClose() {
        setTarget(null);
        onClose();
    }

    return (
        <Popup
            open={open}
            onClose={handleClose}
            onConfirm={handleConfirm}
            title={`Wijzig grootboekrekening (${selectedCount})`}
            Icon={PencilSquareIcon}
            confirmButtonDisplayLabel="Verplaats"
            confirmButtonDisabled={!target || targetIsCurrentAccount}
            confirmButtonDisabledMessage={
                targetIsCurrentAccount
                    ? "Deze boekingen staan al op deze grootboekrekening"
                    : "Kies eerst een grootboekrekening"
            }
        >
            <div className="mt-2 text-left">
                <p className="mb-3 text-sm text-muted-foreground">
                    {selectedCount === 1
                        ? "De geselecteerde boeking wordt verplaatst naar de gekozen grootboekrekening."
                        : `De ${selectedCount} geselecteerde boekingen worden verplaatst naar de gekozen grootboekrekening.`}
                </p>
                <GLASelector
                    accounts={accounts}
                    value={target}
                    onChange={setTarget}
                    label="Grootboekrekening"
                />
            </div>
        </Popup>
    );
}
